<template>
	<div>
		<div class="text-center footer_lc" style="">
			<p class="py-2 footer_lc">สงวนสิขสิทธิ์ พ.ศ. 2564 บริษัท ทีโอเอ เพ้นท์ (ประเทศไทย) จำกัด (มหาชน)</p>
		</div>
	</div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.footer_lc {
	padding-bottom: 0px;
	margin-bottom: 0px;
	background-color: #b9d4cb;
	color: white;
}
</style>